export const defaultDashValueGetter = (value: unknown) => value ?? '-';
